import React from "react";
const Notifications = () => {
  const notifications = [
    {
      id: 1,
      title: "Order Shipped",
      message: "Your order #12345 has been shipped.",
      time: "2 hours ago",
      read: false,
    },
    {
      id: 2,
      title: "Price Drop Alert",
      message: "Price dropped on Samsung Galaxy S23.",
      time: "Yesterday",
      read: true,
    },
    {
      id: 3,
      title: "Wishlist Update",
      message: "An item in your wishlist is almost sold out.",
      time: "2 days ago",
      read: true,
    },
  ];

  return (
    <div className="container">
      <div className="card notification-card border-0">
        <div className="card-body">
          <div className="notification-header">
            <h5>All Notifications</h5>
            <button className="btn btn-link" style={{textDecoration:"none"}}>Mark all as read</button>
          </div>

          {notifications.length === 0 ? (
            <p className="text-center text-muted my-4">
              No notifications available
            </p>
          ) : (
            notifications.map((item) => (
              <div
                key={item.id}
                className={`notification-item ${
                  item.read ? "" : "unread"
                }`}
              >
                <div className="notification-content">
                  <h6>{item.title}</h6>
                  <p>{item.message}</p>
                  <span className="notification-time">{item.time}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
